/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export enum StandardBackupScheduleFrequency {
  STANDARD_BACKUP_SCHEDULE_INTERVAL = 'INTERVAL',
  STANDARD_BACKUP_SCHEDULE_DAILY = 'DAILY',
  STANDARD_BACKUP_SCHEDULE_WEEKLY = 'WEEKLY',
  STANDARD_BACKUP_SCHEDULE_MONTHLY = 'MONTHLY',
  STANDARD_BACKUP_SCHEDULE_ANNUALLY = 'ANNUALLY',
  STANDARD_BACKUP_SCHEDULE_UNSPECIFIED = 'UNSPECIFIED'
}
